import uuid from 'uuid/v1'
import { db } from '../../../config/firebaseconfig'
import queryString from 'query-string'
import getRequest from '../../getRequest';
import addNewAccount from './addNewAccount';

export default function addNewUser(state, role, parentAccount, accountType) {
  const { email, firstName, lastName, username, sfid, password, manualPassword } = state
  if (!role) {
    return addNewAccount(state, parentAccount, accountType)
  }
  const emailLC = email && email.toLowerCase()
  const usernameLC = username && username.toLowerCase()

  const id = uuid()
  const inviteId = uuid()
  const time = Date.now()
  const batch = db.batch()
  
  // the collection the parent account belongs to
  const orgCollection = {
    'Teacher': 'schools',
    'School Admin': 'schools',
    'District Admin': 'districts',
    'Student': 'schools',
  }
  const childCollection = {
    'Teacher': 'teachers',
    'School Admin': 'admins',
    'District Admin': 'admins',
    'Student': 'students'
  }
  const userCollection = role === 'Student' ? 'students' : 'educators'

  const userRef = db.collection(userCollection).doc(id)
  const parentRef = db.collection(orgCollection[role]).doc(parentAccount.id)
  const inviteRef = db.collection('userInvites').doc(inviteId)

  // Add user data submission to batch
  const fullName = `${state.firstName} ${state.lastName}`
  let userData = {
    id,
    email: emailLC,
    username: usernameLC,
    firstName,
    lastName,
    fullName,
    state: parentAccount.state,
    lastModified: time,
    created: time,
    role,
    isTeacher: role === 'Teacher',
    sfid: sfid ? sfid : '',
    validated: manualPassword,
  }
  if (role === 'Teacher' || role === 'Student') {
    userData.classes = {}
  }
  if (role === 'District Admin') {
    userData.schoolDistrict = parentAccount.id
  } else if (role === 'School Admin' || role === 'Teacher' || role === 'Student') {
    userData.schoolDistrict = parentAccount.district
    userData.school = parentAccount.id
  }
  if (role === 'Student') {
    userData.assessments = {}
    userData.username = usernameLC ? usernameLC : emailLC
  } else {
    userData.username = emailLC
  }
  batch.set(userRef, userData)

  // add invite to batch (if no manual password)
  if (!manualPassword) {
    batch.set(inviteRef, {
      id: inviteId,
      userId: id,
      createdDate: time,
      expirationDate: (time + 259200000), 
      firstName,
      lastName,
      email: emailLC,
    })
  }

  // add parent update to batch
  if (childCollection[role]) {
    const parentKey = `${childCollection[role]}.${id}`
    batch.update(parentRef, {[parentKey]: true})
  }

  // check for email/username duplication
  let query = {}, url = ''
  query.email = userData.email
  query.username = userData.username
  query.schoolDistrict = userData.schoolDistrict
  const CHECK_DUP_BASE_URL = 'https://us-central1-bellwork-cg1.cloudfunctions.net/checkDuplication'
  url = `${CHECK_DUP_BASE_URL}?${queryString.stringify(query)}` 
  return getRequest(url)
    .then((resp) => {
      const res = JSON.parse(resp)
      if (res.error) {
        throw res.error
      } else if (!manualPassword) {
        return Promise.resolve()
      } else {
        const data = {id, password,}
        const query = queryString.stringify(data)
        let url = `https://us-central1-bellwork-cg1.cloudfunctions.net/manualAddEducator?${query}`
        if (role === 'Student') {
          url = `https://us-central1-bellwork-cg1.cloudfunctions.net/manualAddStudent?${query}`
        }
        return getRequest(url)
      }
    })
    .then(() => batch.commit())
}


// WEBPACK FOOTER //
// ./src/helpers/users/manageUsers/addNewUser.js